import React from 'react';
import ProductCategoryPage from '../../components/ProductsList/ProductCategoryPage';
import { signageProducts } from '../../data/products';

export default function Signage() {
  return (
    <ProductCategoryPage
      title="도로 안내표지시스템"
      subtitle={"야간 및 악천후 시 시인성을 높여 \n안전 운전을 돕습니다"}
      products={signageProducts}
    />
  );
}
